import { render } from "./TinymceText.vue?vue&type=template&id=715db379"
import script from "./TinymceText.vue?vue&type=script&lang=js"
export * from "./TinymceText.vue?vue&type=script&lang=js"

import "./TinymceText.vue?vue&type=style&index=0&id=715db379&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__